/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9.7885 3.3667C14.995-1.2863 20.2358-.3782 22.307 1.693c2.0727 2.0727 2.9807 7.3196-1.6839 12.5299.8979 4.52-1.414 7.7944-2.8248 8.9487l-.6739.5514-3.2179-3.2179a60.976 60.976 0 0 1-.2438.2c-1.5463 1.261-2.6177 1.9812-3.1711 2.2579l-.6203.3101L.727 14.1287l.3101-.6203c.2767-.5534.9969-1.6248 2.258-3.1711.065-.0799.1317-.1611.2-.2438L.2613 6.86l.5513-.6739c1.1567-1.4137 4.4419-3.732 8.9758-2.8194Zm5.5862 15.8854c1.024-.9002 2.1981-1.9836 3.5197-3.2737.0723 2.328-.8785 4.1001-1.7052 5.0881l-1.8145-1.8144ZM8.0359 5.0909c-2.3427-.0813-4.1258.874-5.118 1.7043l1.83 1.83c.9035-1.0277 1.9916-2.2067 3.288-3.5343Zm9.849 1.0242c-1.315-1.315-3.4471-1.315-4.7622 0-1.315 1.315-1.315 3.4471 0 4.7622 1.3151 1.315 3.4472 1.315 4.7622 0 1.3151-1.315 1.3151-3.4472 0-4.7622ZM1.5574 17.6804l.6803-.6803 4.7622 4.7622-.6803.6803C5.0867 23.6755 3.7194 24 2.6629 24a5.29 5.29 0 0 1-1.275-.1563 4.5056 4.5056 0 0 1-.379-.1119 3.2411 3.2411 0 0 1-.1131-.0414c-.0144-.0055-.0264-.0104-.036-.0143l-.0126-.0052-.005-.0021-.003-.0013s-.001-.0004.378-.8847l-.379.8843-.3537-.1516-.1516-.3537.8843-.379c-.884.3788-.8847.378-.8847.378l-.0004-.0009-.001-.0022-.002-.0049-.0052-.0126a3.2326 3.2326 0 0 1-.0557-.149 4.498 4.498 0 0 1-.112-.379A5.2926 5.2926 0 0 1 0 21.3371c0-1.0565.3245-2.4238 1.5574-3.6567Zm.4345 4.3277c.1816.0369.4113.0677.671.0677.441 0 .9755-.087 1.528-.4012L2.3255 19.809c-.3142.5526-.4012 1.0871-.4012 1.5281 0 .2598.0308.4894.0677.671Z"
    clipRule="evenodd"
  />,
  'MenuDeployFilled'
);
